import { Component, OnInit, Input, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { Payer } from '../../model/payer';
import { FormGroup, FormBuilder, FormArray } from '@angular/forms';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { Contact } from '../../model/contact';
import { ContactBalanceTransactionService } from '../../../invoice/service/data/contact-balance-transaction.service';
import { PaymentMethodService } from '../../../invoice/service/data/payment-method.service';
import { SelectionItem } from '../../../core/component/select/select.component';
import { LocalDate } from '../../../core/model/local-date';
import { switchMap, tap } from 'rxjs/operators';
import { ContactService } from '../../service/data/contact.service';
import { MessageService } from '../../../core/service/message.service';
import { Subscription } from 'rxjs';
import { ContactCompanyBalance } from '../../../invoice/model/contact-company-balance';

@Component({
    selector: 'app-repay-balance-form',
    templateUrl: './repay-balance-form.component.html',
    styleUrls: ['./repay-balance-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RepayBalanceFormComponent implements OnInit, OnDestroy {
  constructor(
    private _dialogService: ActionWindowService,
    private _balanceService: ContactBalanceTransactionService,
    private _contactService: ContactService,
    private _messageService: MessageService,
    private _fb: FormBuilder,
    private _fcf: FormControlExFactory,
    private _paymentMethodService: PaymentMethodService
  ) {}
  private _dataContext: Contact;
  @Input() set dataContext(dataContext: Contact) {
    this._dataContext = dataContext;
  }

  get dataContext(): Contact {
    return this._dataContext;
  }

  form: FormGroup;
  forms: FormArray;
  private _sub: Subscription = new Subscription();

  cancel() {
    this._dialogService.close();
  }

  ngOnDestroy(): void {
    this._sub.unsubscribe();
    if (this._repaySub) this._repaySub.unsubscribe();
  }

  balances: ContactCompanyBalance[];

  accountSelections: SelectionItem[][];

  ngOnInit() {
    this._sub.add(
      this._balanceService.getCompanyBalances(this.dataContext.id).subscribe(balances => {
        this.accountSelections = [];
        for (let balance of balances) {
          let items = balance.companyBankAccounts.map(a => new SelectionItem(a.name, a.id));
          items.splice(0, 0, new SelectionItem('CONTACT_BALANCE_TRANSACTION.CASH_PAYMENT', null));
          this.accountSelections.push(items);
        }

        this.balances = balances;
        this.forms = this._fb.array(
          balances.map(balance =>
            this._fb.group({
              amount: this._fcf.createWithOptions('OUTBOUND_PAYMENT.AMOUNT', balance.balance, {
                required: true,
                maxValue: balance.balance.amount,
                minValue: 0,
              }),
              companyId: this._fcf.createHidden(balance.companyId),
              companyCaption: this._fcf.createReadonly('COMMON.COMPANY', balance.companyCaption),
              companyBankAccountId: this._fcf.create(
                'CONTACT_BALANCE_TRANSACTION.REPAID_FROM',
                balance.companyBankAccounts.length > 0 ? balance.companyBankAccounts[0].id : null
              ),
            })
          )
        );

        this.form = this._fb.group({
          contactId: this._fcf.createHidden(this.dataContext.id),
          accountingDate: this._fcf.createMandatory('REGISTER_PAYMENT.DATE', LocalDate.today()),
          repayments: this.forms,
        });
      })
    );
  }

  private _working = false;
  private _repaySub: Subscription;
  onSubmit() {
    if (this.form.invalid || this._working) return;

    this._working = true;
    if (this._repaySub) this._repaySub.unsubscribe();
    const values = this.form.value;
    this._repaySub = this._balanceService.repay(this.form.value).subscribe(
      transactions => {
        for (const transaction of transactions) {
          this.dataContext.contactBalanceTransactions.push(transaction);
        }
        this.dataContext.creditBalance -= values.amount;
        this._messageService.showSuccess();
        this._dialogService.complete(transactions);
      },
      () => {
        this._working = false;
      }
    );
  }
}
